export const SET_USER = "setUser";
export const SET_SPORTS = "setSports";
export const SET_PACKAGES = "setPackages";
export const SET_CATS = "setCategories";
export const SET_PICKS = "setPicks";
export const SET_EDIT_USER = "setEditUser";
export const SET_CURRENT_PACKAGE = "setCurrentPackage";

export const SET_ODDS = "setOdds";
export const SET_SPORT = "setSport";

// Shop mutations
export const SET_PRODUCTS = "setProducts";
export const SET_CURRENT_PRODUCT = "setCurrentProduct";
export const ADD_TO_CART = "addToCart";
export const UPDATE_CART_ITEM = "updateCartItem";
export const REMOVE_FROM_CART = "removeFromCart";
export const CLEAR_CART = "clearCart";



// WEBPACK FOOTER //
// ./src/store/mutation-types.js